<!-- 读卡器页面 -->
<template>
	<div class="fuzzy-matching-box">
		<!-- 读卡器页面 -->
		<div class="fuzzy-matching-top">
			<el-row class="top-first-line the-second-line">
				<el-col :span="5">
					<el-form-item label="IMEI:">
						<el-input v-model="Dform.readerCardName" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="学校:">
						<el-input v-model="Dform.className" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="DEVICEID:">
						<el-input v-model="Dform.readerCardCode" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
				</el-col>
				<el-button type="primary" class="query-button" @click="entrylogClick">查询</el-button>
			</el-row>
			<el-button type="text" class="textButton" @click="AddClick">新增读卡器</el-button>

		</div>
		<div class="fuzzy-matching-bottom">
			<el-row class="list">
				<el-table stripe :border="true" v-loading="loading"
					:header-cell-style="{background:'#EDF6FF',color:'#000',}" ref="multipleTable" :data="tableData"
					tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column prop="readCardName" label="IMEI">
					</el-table-column>
					<el-table-column prop="code" label="DEVICEID">
					</el-table-column>
					<el-table-column prop="schoolName" label='学校'>
					</el-table-column>
					<el-table-column prop="mobile" label="电话">
					</el-table-column>
					<el-table-column prop="loginTime" label="操作">
						<template #default="scope">
							<el-button class="textButton" type="text" size="small"
								@click="xiugaiClick(scope.row)">修改</el-button>
							<el-button class="shanchuBtn" type="text" size="small"
								@click="deleteClick(scope.row)">删除</el-button>
						</template>
					</el-table-column>
					<!-- <el-table-column
            prop="userName"
            label="状态"
            >
          </el-table-column> -->

				</el-table>

				<div class="block-fenye">
					<el-pagination :small="small" :disabled="disabled" :background="background"
						layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
						@current-change="handleCurrentChange" />
				</div>
			</el-row>

		</div>
		<Add v-if="CardAddShow" @AddShowClick="AddShowClick" :xiugaiObj="xiugaiObj"></Add>

	</div>
</template>

<script>
	import Add from './CardreadingAdd/add.vue'
	import { ElMessage } from 'element-plus'
	import {
		readerCardList,
		readerCardDelete
	} from '@/assets/api/schoollog';
	export default {
		components: {
			Add
		},
		data() {
			return {
				CardAddShow: false,
				loading: true,
				Dform: {
					code: "",
					name: "",
					schoolName: "",
				},
				total: '',
				pageInfo: {
					pageSize: "10",
					page: "1",
				},
				tableData: [],
				xiugaiObj: {}
			};
		},
		created() {
			this.readerCardListSearch()
		},
		mounted() {

		},
		methods: {
			//xiugaiClick修改
			xiugaiClick(imei) {
				// console.log(imei.readPointId,'修改');
				this.xiugaiObj = imei
				this.CardAddShow = true
			},
			// 新增
			AddClick() {
				this.CardAddShow = true

			},
			AddShowClick() {
				this.CardAddShow = false
				this.xiugaiObj = {}
				this.readerCardListSearch()
			},
			//删除
			deleteClick(row) {
				const params = {
					id: row.readCardId
				}

				this.$confirm('请确认是否删除该读卡器!', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					readerCardDelete(params).then((res) => {
					this.readerCardListSearch()
					ElMessage.success('删除成功')
					})
				}).catch((err) => {
					console.log(err, '关机');
					this.$message({
						type: 'error',
						message: err.response.data.msg||'接口异常'
					});
				});
			},
			readerCardListSearch() {
				const params = {
					readerCardCode: this.Dform.readerCardCode,
					readerCardName: this.Dform.readerCardName,
					className: this.Dform.className,
					page: this.pageInfo.page,
					pageSize: this.pageInfo.pageSize,
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				readerCardList(params).then((res) => {
					console.log(res, '读卡器成功');
					this.tableData = res.data.data.list
					this.total = res.data.data.total
					this.loading = false

				}).catch((err) => {
					console.log(err, '读卡器失败');

				})
			},
			entrylogClick() {
				this.readerCardListSearch()
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageInfo.page = val
				this.readerCardListSearch()
			},
		},
	};
</script>

<style scoped lang="scss">
	.fuzzy-matching-box {
		padding-top: 30px;
		// overflow: hidden;
		// overflow: auto;
		width: 100%;
		height: 96%;
		background-color: #fff;
		border-radius: 8px;

		.textButton {
			// background-color: pink;
			margin: 2px;
			padding: 10px;
			font-size: 15px;
			font-weight: 700;
		}

		.title-top {
			padding: 20px 20px;
		}

		.fuzzy-matching-top {
			height: 100px;
			background-color: #fff;
			border-radius: 8px;

			.top-first-line {

				:deep() {
					.el-form-item--small .el-form-item__label {
						// background-color: red;
						font-size: 16px;
					}

					.el-select--small {
						width: 100%
					}

					.el-form-item--small .el-form-item__label {
						width: 110px;
						text-align: right;
						height: 35px;
						line-height: 35px;
					}

					.el-input {
						width: 100%;
						height: 35px;
					}

				}
			}

			.the-second-line {
				margin-top: 15px;
				position: relative;

				.query-button {
					position: absolute;
					right: 500px;
					padding: 16px 24px;
					// top: 50%;
					// transform: translate(0,-50%);
					// background-color: #1677FF;
				}


			}

			:deep() {
				.el-range-editor--small.el-input__wrapper {
					height: 35px;
					line-height: 35px;
				}

				.el-button--text {
					margin-left: 40px;
					font-size: 18px !important;
					margin-top: 15px;
				}
			}

		}

		.fuzzy-matching-bottom {
			// position: absolute;
			padding: 20px;

			.textButton {
				// background-color: pink;
				margin: 2px;
				padding: 10px;
				font-size: 15px;
				font-weight: 700;
			}

			.shanchuBtn {
				// background-color: pink;
				margin: 2px;
				padding: 5px;
				font-size: 15px;
				font-weight: 700;
				color: red;
			}

			:deep() {
				.el-table th.el-table__cell>.cell {
					height: 30px;
					line-height: 30px;
					text-align: center;
					font-size: 15px;
					font-weight: 700;
				}

				.el-table td.el-table__cell div {
					text-align: center;
					height: 35px;
					line-height: 35px;
					border: 0;
					font-size: 16px;
				}

				.el-table:not(.el-table--border) .el-table__cell {
					border: 0;
				}

				.el-button--text {
					font-size: 16px !important;
				}
			}

			.block-fenye {
				margin-left: 1000px;
				margin-top: 15px;
			}
		}

	}
</style>